module.exports = __webpack_public_path__ + "img/datasets.956edbbd.svg";